module.exports = __webpack_public_path__ + "static/media/serieNaRealLogo.a2a34d05.jpg";